import Header from './Header';

function Portfolio() {
    return (
        <div>
            <div className="page">
                <a className="return" href={`${process.env.PUBLIC_URL}/`}><i class="fa-solid fa-left-long"></i></a>
                <div className="box">
                    <img src={`${process.env.PUBLIC_URL}/noimage.png`} />
                    <h1>Yoshi Portfolio</h1>
                    <p>成果物をひけらかすWebサイト。</p>
                    <div className="items">
                        <p><span>HTML</span><span>css</span><span>React</span><span>Apache</span><span>ubuntu server</span></p>
                    </div>
                </div>
                <div className="box">
                    <h2>概要</h2>
                    <p>このサイトです。就活用にポートフォリオを作り始めたのですが、なんかうまくできなかったのでSNS用に転用しました。</p>
                </div>
            </div>
        </div>
    )
}

export default Portfolio;